import kkcRequest, { Options } from '@/../../common/src/utils/requests/request';
import { ProductType } from '@/AppGlobal';
import {
  ClCheckInfoV2,
  ClIncreaseCreditLimitDto,
  CreditApplyLimitDto,
  IncreaseCreditLimit,
  MarketingEligibilityData,
  MarketingRecommendationData,
  PaymentDTO,
  RemainPrincipalDto,
  WithdrawalMarketingType,
} from '@/interface/CL/clCredit';
import {
  BankCardType,
  ContractInfoType,
  CouponIssueUserDto,
  repaymentPlanList,
} from '@/interface/sharedTypes';
import { LoanEntity } from '@/interface/KKC/withdrawal';
import { transformCouponData } from '@/utils/transformCouponData';
import { clRequest as clrequest } from '@/utils/request';
import { getGlobalUserInfo } from '@/utils/singletonUtils';
import VhkStore from '@/vhkstore';
import { setCreditApply } from '@/vhkstore/slices/CL/clCredit';
import request from '@web/common/src/utils/requests/request';
import { creditApply } from './interface';

// byClaude-start 2026-07-01 17:00:00
export { queryProductIntroduceInfo } from '@/utils/sharedApis';
// byClaude-end 2026-07-01 17:00:00

export const submitLoanApi = (data: PaymentDTO, loading = true) =>
  request.post<{ orderId: string }>(
    '/credit/pay/createOrUpdateApplicationInfo',
    data,
    { loading },
    { productCode: data.productCode }
  );

export const queryLoanInfoFromOrderId = (orderId: string, productCode: ProductType) =>
  request.post<any>(
    `/credit/pay/getApplyInfoByOrderIdV2`,
    { orderId },
    { loading: true },
    { productCode }
  );

export const checkBeLimit = (params: { userId: string; funcLimitCode: string }) =>
  request.post<any>(`/credit/app/label/check/user/limit`, params, { loading: true });

export const clDcConfirm = () => request.post('/credit/pay/dc-confirm', null, { loading: true });

// byClaude 2026-07-02 10:23:59 — 迁移至 sharedApis
export { queryListSettlePayOrders } from '@/utils/sharedApis';

// byClaude-start 2026-08-26 15:20:28
export { queryCrossProductListSettlePayOrders } from '@/utils/sharedApis';
// byClaude-end 2026-08-26 15:20:28

// 确认订单时查询是否有勾选清还贷款
export const sureTerms = (orderId: string) => request.post('/credit/pay/sureTerms', { orderId });

// 请求贷款合约内容
// byClaude-start 2026-08-25 18:24:12 - 增加 productCode 参数，透传具体产品
export const queryLoanContractContent = (orderId: string, productCode: ProductType) =>
  request.post<string[]>(
    '/credit/pay/readContractContent',
    { orderId, refactoredVersion: true },
    { loading: true, hideError: true },
    { productCode }
  );
// byClaude-end 2026-08-25 18:24:12

/**
 * 根据优惠券ID查询优惠券信息
 
 * @param params - 查询参数，包含优惠券ID
 * @returns 转换后的优惠券数据
 */
export const queryCouponInfoById = (params: { couponId: string }) =>
  request
    .post<CouponIssueUserDto>(`/credit/coupon/queryCouponInfoById`, params, { loading: true })
    .then((res) => transformCouponData(res));
// - 营销方案相关接口
// 营销资格检查和AB测试
export const checkMarketingEligibility = (params: { orderId: string; productLabel: ProductType }) =>
  request.post<MarketingEligibilityData>('/credit/clPay/marketing/abtestAndEligible', params);

// 营销方案计算和推荐
export const getMarketingRecommendation = (params: {
  orderId: string;
  planType: WithdrawalMarketingType;
}) =>
  request.post<MarketingRecommendationData>('/credit/clPay/queryMarketingPlan', params, {
    loading: true,
  });

// byClaude 2026-07-02 10:23:59 — 迁移至 sharedApis
export { queryMarketingTimeLimit, queryByMarketingOrderId } from '@/utils/sharedApis';

// - 确认营销方案接口
/**
 * 确认营销方案
 * @param params 参数对象，包含 orderId 和 planId
 
 */
export const confirmMarketingPlan = (params: {
  orderId: string;
  planId?: string;
  marketingOrderId?: string;
}) =>
  request.post<string>('/credit/clPay/marketing/confirm', params, {
    loading: true,
  });

// byClaude-start 2026-06-26 12:00:00 - 从 credit/api.ts 迁移的共享 API 函数
export const introCaculator = (fillInItems: any) =>
  clrequest.post<{
    max: number;
    min: number;
    interestCategory: string;
  }>('credit/nl/product/loan/calculator', fillInItems);

export const queryClCreditInfo = (options?: Options, params?: creditApply) =>
  clrequest
    .post<creditApply>('credit/clCredit/selectNode', params, options)
    .then((res) => {
      VhkStore.dispatch(setCreditApply({ creditApply: res }));
      return res;
    })
    .catch((err) => {
      console.log('queryClCreditInfo err', err);
      return Promise.reject(err);
    });

export const executeFlow = (params?: creditApply, options?: Options) =>
  clrequest
    .post<creditApply>('credit/clCredit/executeFlow', params, { loading: true, ...options })
    .then((res) => {
      VhkStore.dispatch(setCreditApply({ creditApply: res }));
      return res;
    })
    .catch((err) => {
      console.log('executeFlow err', err);
      return Promise.reject(err);
    });

// byClaude-start 2026-07-01 16:30:00
export { queryClCreditLimit } from '@/utils/sharedApis';
// byClaude-end 2026-07-01 16:30:00

export const queryClLoanInfo = (options?: Options) =>
  clrequest.post<PaymentDTO>('credit/clPay/payCheck', null, options);

export const clRepaymentPlan = (params: PaymentDTO, options?: Options) =>
  clrequest.post<PaymentDTO>('/credit/clPay/repaymentPlan', params, {
    ...options,
    hideError: true,
  });

export const clRepaymentPlanPreApprove = (params: PaymentDTO) =>
  clrequest.post<PaymentDTO>('/credit/clPay/repaymentPlanPreApprove', params);

// byClaude 2026-07-02 10:23:59 — 迁移至 sharedApis
export { querySelectedBank } from '@/utils/sharedApis';

export const queryIsNeedOtp = () =>
  clrequest.post(
    '/credit/clPay/isNeedOtp',
    {},
    {
      hideError: true,
      loading: true,
    }
  );

export const clPayExecuteFlow = (
  params: PaymentDTO & { productLabel?: string },
  loading = true,
  hideError = false
) => clrequest.post('/credit/clPay/executeFlow', params, { loading, hideError });

export const clPayH5ExecuteFlow = (params: { request: string }, loading = true) =>
  clrequest.post('/credit/clPay/h5/executeFlow', params, { loading });

// byClaude-start 2026-07-01 16:30:00
export { queryClOrderInfo } from '@/utils/sharedApis';
// byClaude-end 2026-07-01 16:30:00

export const repaymentPlan = (params: {
  loanMaturity: number;
  loanAmt: number;
  paymentBankFlows: BankCardType[];
}) => clrequest.post<repaymentPlanList>('credit/clPay/repaymentPlan', params);

export const selectLimitInfo = () =>
  clrequest.post<CreditApplyLimitDto>('credit/limit/selectLimitInfo');

export const selectLimitState = () =>
  clrequest.post<IncreaseCreditLimit>('credit/limit/selectLimitState', {}, { hideError: true });

export const queryWeatherNewAppeal = () =>
  clrequest.post<ClCheckInfoV2>('credit/limit/clCheckInfo/v2', {}, { hideError: true });

export const selectLimitRecord = (productCode?: string) =>
  kkcRequest.post<Array<ClIncreaseCreditLimitDto>>(
    'credit/limit/selectLimitRecord',
    null,
    {},
    { productCode: productCode || 'CL' }
  );

export const increaseLimitOps = (params: any) =>
  clrequest.post<creditApply>('credit/limit/increaseLimitOps', params);

export const uploadCreditFile = (params: any) =>
  clrequest.post<creditApply>('credit/clCredit/uploadCreditFile', params);

export const downloadContactPdf = (params: LoanEntity) =>
  clrequest.post<ContractInfoType>('/credit/pay/download', params, { loading: true });

// byClaude-start 2026-07-01 16:30:00
export { queryAppliedProduction } from '@/utils/sharedApis';
// byClaude-end 2026-07-01 16:30:00

export const queryblackProduction = async (option?: Options) =>
  clrequest.get<boolean>(
    `/credit/bill/label-face/${(await getGlobalUserInfo()).userId}`,
    {},
    { loading: true, ...option }
  );

export const isClCanShowInvitationCode = () =>
  clrequest.post<{
    isShow: boolean;
  }>('/credit/apply/isCanShowInvitationCode');

// byClaude 2026-07-02 10:23:59 — 迁移至 sharedApis
export { checkHasSlaPassMuster, queryReduceCouponVal } from '@/utils/sharedApis';

export const preApproveSureInfoCheck = () =>
  clrequest.post('credit/clCredit/preApproveSureInfoCheck');

export const queryIsFirstLoan = (productType: ProductType) =>
  clrequest.get<boolean>(`/credit/pay/getIsFirstLoan?productCode=${productType}`);

export const queryRemainPrincipal = (params: { productCode: ProductType }) =>
  clrequest.post<RemainPrincipalDto>(`/credit/query/remainPrincipal`, params);
// byClaude-end 2026-06-26 12:00:00

// Contains claude-generated edits.
